import React, { Component } from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { toast } from 'react-toastify';
import BugReportForm from '../../partials/bug-report-form';
import ErrorReportModal from './error-report-modal';
import { ButtonText } from '../../tw-partials/button';

const ReportButton = styled(ButtonText)`
  ${tw`p-0 ml-4 underline hover:text-blue-800`};
`;

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      hasLocalError: false,
      isModalOpen: false,
      reportOpen: false,
      formId: '',
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasLocalError: true,
      error,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasError } = this.props;

    if (prevProps.hasError !== hasError && !hasError) {
      this.resetError();
    }
  }

  componentDidCatch(error) {
    const { match, setErrorState } = this.props;
    const { formId } = match.params;

    // eslint-disable-next-line no-console
    console.log({ error });

    this.setState({ isModalOpen: true, error, formId });

    toast.error('An error occurred', {
      toastId: 'error-boundary',
    });

    setErrorState(true);
  }

  // closeModal = (message) => {
  //   const { doReportError, title } = this.props;
  //   const { error, formId } = this.state;

  //   doReportError(title, formId, error, message || '');

  //   this.setState({
  //     isModalOpen: false,
  //     reportOpen: false,
  //   });
  // };

  // openModal = () => {
  //   this.setState({
  //     reportOpen: true,
  //   });
  // };

  resetError = () => {
    this.setState({
      hasLocalError: false,
    });
  };

  submitReport = (message) => {
    this.closeModal(message);
  };

  handleReportForm = () => {
    this.setState((prevState) => ({
      reportOpen: !prevState.reportOpen,
    }));
  };

  render() {
    const { children, content } = this.props;
    const { hasLocalError, reportOpen } = this.state;

    if (hasLocalError) {
      return (
        <>
          <p>
            {content || 'An error has occurred. Please submit a crash report and reload to clear errors'}
            <ReportButton type="primary" onClick={this.handleReportForm}>
              Submit report
            </ReportButton>
          </p>
          {/* {isModalOpen && (report || reportOpen) && (
            <ErrorReportModal
              closeModal={this.closeModal}
              sendingError={sendingError}
              submitReport={this.submitReport}
            />
          )} */}

          {reportOpen && <BugReportForm handleReportForm={this.handleReportForm} />}
        </>
      );
    }
    return children;
  }
}

ErrorBoundary.defaultProps = {
  report: false,
  content: '',
  hasError: false,
};

ErrorBoundary.propTypes = {
  sendingError: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  doReportError: PropTypes.func.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  report: PropTypes.bool,
  content: PropTypes.string,
  hasError: PropTypes.bool,
  setErrorState: PropTypes.func.isRequired,
};
